<template>
  <a class="back-to-top"
     @click="scrollToTop">
    {{ $t('backToTop') }}
    <i class="fas fa-chevron-up"></i>
  </a>
</template>
<script>
export default {
  name: 'back-to-top',
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
      ;
    }
  }
}
</script>


<style>
.back-to-top {
cursor: pointer;
}
</style>